import { formatRegion } from '@platform/design-system';
import type { CatalogOption } from '../../catalog/options.ts';
import { originOptionOf } from '../../catalog/origin.ts';

export type OriginChoice = { readonly value: string; readonly label: string };

export type OriginChoiceLabels = {
  readonly all: string;
  readonly local: string;
  readonly allImported: string;
  readonly imported: (country: string) => string;
};

export const LOCAL_ORIGIN = 'local';
export const IMPORTED_ORIGIN = 'imported';

const countriesInUse = (options: readonly CatalogOption[]): readonly string[] => [
  ...new Set(
    (originOptionOf(options)?.values ?? []).flatMap((value) =>
      value.countryCode === null ? [] : [value.countryCode],
    ),
  ),
];

export const originChoicesOf = (
  options: readonly CatalogOption[],
  labels: OriginChoiceLabels,
  locale: string,
): readonly OriginChoice[] => {
  const collator = new Intl.Collator(locale);
  const countries = countriesInUse(options)
    .map((code) => ({ value: code, label: labels.imported(formatRegion(code, locale)) }))
    .toSorted((left, right) => collator.compare(left.label, right.label));
  return [
    { value: '', label: labels.all },
    { value: LOCAL_ORIGIN, label: labels.local },
    { value: IMPORTED_ORIGIN, label: labels.allImported },
    ...countries,
  ];
};
